import {
  IItemToRequest,
  MyPurchaseForm,
} from 'src/app/shared/models/app-models';
import SourcingStatusJSON from 'src/app/data/constants/SourcingStatus.json';
import { DecimalPipe } from '@angular/common';
import { Vendor } from 'src/app/shared/models/database-models';

export interface IItemTable {
  itemId: number;
  displayItemNumber: number;
  PurchaseItemId: string | null;
  SourcingStatus: string;
  MaterialSubGroupId: string | null;
  MaterialSubGroupNameId: string | null;
  ItemDescription: string;
  Quantity: string;
  UnitOfMeasurement: string;
  Currency: string;
  UnitPrice: string;
  UnitsPerQuantity: string;
  TotalAmount: string;
  PartModelNumber: string;
  PlannedDeliveryDate: Date;
  Criticality: string | null;
  Brand: string | null;
  isDeleted: boolean;
  Strikethrough: boolean;
}

export const getItemTotalAmountInItemCurrency = (item: IItemToRequest) => {
  return (
    (item.ItemPrice.Quantity * item.ItemPrice.UnitPrice) /
    item.ItemPrice.UnitsPerQuantity
  );
};

export const itemToTableDisplay = (
  item: IItemToRequest,
  decimalPipe: DecimalPipe
) => {
  let totalAmountInItemCurrency = getItemTotalAmountInItemCurrency(item);

  let formattedItem: IItemTable = {
    itemId: item.AddItems.itemId,
    displayItemNumber: item.AddItems.displayItemNumber,
    PurchaseItemId: item.AddItems.PurchaseItemId?.toString() ?? null,
    SourcingStatus:
      SourcingStatusJSON.find((status) => {
        return status.SourcingStatusId == item.AddItems.SourcingStatusId;
      })?.name ??
      (item.AddItems.TaggedVendors ? 'Potential vendor identified' : ''),
    MaterialSubGroupId: item.AddItems.MaterialSubGroupId?.Name ?? null,
    MaterialSubGroupNameId: item.AddItems.MaterialSubGroupId?.Name ?? null,
    ItemDescription: item.AddItems.ItemDescription ?? null,
    Quantity:
      decimalPipe.transform(item.ItemPrice.Quantity, '1.3-3') ?? '0.000',
    UnitOfMeasurement: item.ItemPrice.UnitOfMeasurement.value,
    Currency: item.ItemPrice.Currency.value,
    UnitPrice: decimalPipe.transform(item.ItemPrice.UnitPrice, '1.2') ?? '0.00',
    UnitsPerQuantity:
      decimalPipe.transform(item.ItemPrice.UnitsPerQuantity, '1.2') ?? '0.00',
    TotalAmount:
      decimalPipe.transform(totalAmountInItemCurrency, '1.2-2') ?? '0.00',
    PartModelNumber: item.AddItems.PartModelNumber,
    PlannedDeliveryDate: item.AddItems.PlannedDeliveryDate,
    Criticality: item.AddItems.CriticalityId?.value ?? null,
    Brand: (item.AddItems.BrandOEMName && item.AddItems.BrandOEMName.value !== 'Others' ? item.AddItems.BrandOEMName?.value : item.AddItems.BrandOEMNameCustom) ?? null,
    isDeleted: item.isDeleted ? true : false,
    Strikethrough: item.Strikethrough,
  };

  return formattedItem;
};

export const getVendorEmailAddress = (vendor: Vendor): string => {
  if (vendor.OtherPersonEmail && vendor.OtherPersonEmail.trim().length > 0)
    return vendor.OtherPersonEmail.trim();
  else if (vendor.EmailAddress && vendor.EmailAddress.trim().length > 0)
    return vendor.EmailAddress.toString();
  return '-';
};

export const getVendorContactPerson = (vendor: Vendor): string => {
  if (vendor.ContactPersonID === null || vendor.ContactPersonID === undefined) {
    return '-';
  }
  if (vendor.ContactPersonID === 0) {
    return vendor.OtherPersonName || '-';
  }
  return vendor.VendorContactPerson || '-';
};